import { LoginForm } from "@/auth/components/login";
import { Layout } from "@/ui/layouts";
import { Page } from "@/types/generics";
import { GetServerSideProps } from "next";
import styled from "styled-components";
import { colors } from "@/styles/colors";

type Props = Page;
function Login({ meta }: Props) {
  return (
    <Layout meta={meta}>
      <Container>
        <div className="decoration">
          <div className="box b1" />
          <div className="box b2" />
          <div className="box b3" />
        </div>

        <div className="form-container">
          <img className="logo" src="/images/servicom-logo.svg" />
          <LoginForm />
        </div>
      </Container>
    </Layout>
  );
}

const Container = styled.main`
  display: grid;
  place-items: center;
  width: 100%;
  max-width: 100vw;

  height: 100vh;
  max-height: 100vh;
  overflow: hidden;

  background: linear-gradient(
    30deg,
    #${colors.primary._500},
    #${colors.primary._800}
  );

  .logo {
    display: flex;
    width: 70%;
    margin: 0 auto 2.5rem auto;
  }

  > .decoration {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .box {
      position: absolute;
      display: flex;
    }

    .box.b1 {
      top: 0;
      left: 0;
      width: 20rem;
      height: 20rem;
      background: #fff5;
      transform: translate(-20%, -20%) rotate(20deg);
    }
    .box.b2 {
      top: 50%;
      left: 50%;
      width: 40rem;
      height: 40rem;
      background: #fff2;
      transform: translate(-50%, -30%) rotate(20deg);
    }
    .box.b3 {
      top: 0%;
      left: 100%;
      width: 30rem;
      height: 30rem;
      background: #fff6;
      transform: translate(-20%, -50%) rotate(20deg);
    }
  }

  > .form-container {
    position: relative;
    background: #fff;
    padding: 2.5rem;
    box-shadow: 0 25px 20px -20px #${colors.primary._300}ff;
    min-width: 360px;
  }
`;

export default Login;

export const getServerSideProps: GetServerSideProps<Props> = async (ctx) => {
  return {
    props: {
      data: null,
      meta: { title: "Iniciar Sesion | Servicom", description: "" },
    },
  };
};
